import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import type { ClientApi } from '@openclassrooms/sdk-web';
import type { CompletionState } from '../types';
type UseEmbeddedChapterCompletionProps = {
  client: ClientApi;
  chapterId: number;
  setCompletionState: (state: CompletionState) => void;
  setIsAlreadyCompletedByUser: (value: boolean) => void;
};
type UseEmbeddedChapterCompletionResult = {
  handleMarkAsComplete: () => void;
};
type ErrorWithStatusCode = {
  statusCode?: number;
};
const isConflictError = (error: ErrorWithStatusCode | null | undefined): boolean => error?.statusCode === 409;

/**
 * @param client - API client for chapter operations
 * @param chapterId - ID of chapter to mark complete
 * @param setCompletionState - callback to update UI completion state ('loading' | 'completed' | 'error')
 * @param setIsAlreadyCompletedByUser - callback to mark chapter as completed at parent level
 */
const useEmbeddedChapterCompletion = t0 => {
  const $ = _c(10);
  const {
    client,
    chapterId,
    setCompletionState,
    setIsAlreadyCompletedByUser
  } = t0;
  let t1;
  if ($[0] !== setCompletionState || $[1] !== setIsAlreadyCompletedByUser) {
    t1 = () => {
      setIsAlreadyCompletedByUser(true);
      setCompletionState("completed");
    };
    $[0] = setCompletionState;
    $[1] = setIsAlreadyCompletedByUser;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const applyCompletionSuccess = t1;
  let t2;
  if ($[3] !== applyCompletionSuccess || $[4] !== chapterId || $[5] !== client || $[6] !== setCompletionState) {
    t2 = () => {
      setCompletionState("loading");
      client.helpers.learningContent.chapters.completeChapter(chapterId).then(applyCompletionSuccess).catch(error => {
        if (isConflictError(error)) {
          applyCompletionSuccess();
        } else {
          setCompletionState("error");
        }
      });
    };
    $[3] = applyCompletionSuccess;
    $[4] = chapterId;
    $[5] = client;
    $[6] = setCompletionState;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleMarkAsComplete = t2;
  let t3;
  if ($[8] !== handleMarkAsComplete) {
    t3 = {
      handleMarkAsComplete
    };
    $[8] = handleMarkAsComplete;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default useEmbeddedChapterCompletion;